export default "__VITE_ASSET__467d2f8e__"